import UserbackService from './UserbackService.js';
import { Modes } from '../common.js';
import IntercomService from '@/utils/IntercomService';
import CustomerIOService from '@/utils/customer-io.js';
import { identifySegmentUser, trackPageVisitedSegment } from '@/utils/segmentAnalytics';
import SmartLookService from '@/utils/smartlook';

// import mixpanel from 'mixpanel-browser';

/* Private */

const applyFn = (fn) => {
	// Validates that the service runs only on relevant environments
	// and handles exceptions - we cannot fail because external services\libraries
	try {
		if (process.env.NODE_ENV === Modes.Production) {
			return fn();
		}
	} catch (err) {
		console.error(err);
		return null;
	}
};

/* Public */

const initAnalytics = () => {
	//todo: token should probably reside in the env file
	// applyFn(() => {
	// 	mixpanel.init('1f8972024b14f1c3459d03adc7c57ee4');
	// });
};

const identifyUser = (user) => {
	applyFn(() => {
		identifySegmentUser(user.id, {
			first_name: user.first_name,
			last_name: user.last_name,
			email: user.email,
			workspace_id: user?.profile?.account?.id,
		});

		SmartLookService.identifyUser(user);
		CustomerIOService.identifyUser(user);
	});
	IntercomService.init(user);
	UserbackService.init(user);
};

// These are general user props stored at the Analytics provider
// props: object with properties to update. e.g. props = { "Plan": "Premium" }
const updateUserProps = (props) => {
	applyFn(() => {
		window.analytics.identify(props);
	});
};

const trackPageVisited = (routeTo) => {
	// (!) Mixpanel tracks page view by default
	applyFn(() => {
		trackPageVisitedSegment(routeTo);
	});
};

const sendEvent = (eventName, props) => {
	applyFn(() => {
		window.analytics.track(eventName, props);
	});
};

const AnalyticsService = {
	initAnalytics,
	updateUserProps,
	identifyUser,
	trackPageVisited,
	sendEvent,
};

export default AnalyticsService;
